<div class="list-group list-group-flush">
  <a class="list-group-item list-group-item-action" *ngFor="let r of requirements; let i = index" (click)="toggle(i)">

    <div class="row align-items-center">

      <div class="col-auto pe-2">
        <i class="fa-sharp fa-solid fa-circle-check" [class.text-success]="r.IsMatch"
          [class.text-muted]="!r.IsMatch"></i>
      </div>

      <div class="col col-shrink">
        <div class="fw-bold oneline">{{ title(r) }}</div>
      </div>

      <div class="col-auto text-muted">
        <i class="fa-regular fa-chevron-down chevron" [class.expanded]="expanded[i]"></i>
      </div>

    </div>

    <div class="reasoning mt-3" *ngIf="expanded[i]" [@expand]>
      <p class="fw-normal mb-0 py-0">{{ r.Reasoning }}</p>
    </div>

  </a>
</div>